import type { ManagementTranslations } from '../en-US/management.translations';

export const managementTranslations: ManagementTranslations = {
  title: 'Gestion BiteCritic',
  dashboard: 'Tableau de Bord',
  users: 'Gestion des Utilisateurs',
  settings: 'Paramètres',
  foods: {
    title: 'Gestion des Aliments',
    createNew: 'Ajouter un Nouvel Aliment',
    id: 'ID',
    name: 'Nom',
    category: 'Catégorie',
    country: 'Pays',
    status: 'Statut',
    createdAt: 'Créé le',
    actions: 'Actions',
    noFoodsFound: 'Aucun aliment trouvé',
    searchPlaceholder: 'Rechercher des aliments...',
    allStatuses: 'Tous les Statuts',
    allCategories: 'Toutes les Catégories',
    sortNewest: "Plus Récents d'abord",
    sortOldest: "Plus Anciens d'abord",
    sortNameAZ: 'Nom A-Z',
    sortNameZA: 'Nom Z-A',
    showing: 'Affichage de {{from}} à {{to}} sur {{total}} aliments',
    confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet aliment ?',
    approve: 'Approuver',
    reject: 'Rejeter',
    createFood: 'Créer un Nouvel Aliment',
    editFood: "Modifier l'Aliment",
    viewFood: "Voir les Détails de l'Aliment",
    namePlaceholder: "Saisir le nom de l'aliment",
    descriptionPlaceholder: "Saisir la description de l'aliment",
    selectCategory: 'Sélectionner une catégorie',
    selectCountry: 'Sélectionner un pays',
    selectStatus: 'Sélectionner un statut',
    imageUrl: "URL de l'image",
    imageUrlPlaceholder: "Saisir l'URL de l'image",
    imagePreview: "Aperçu de l'image",
    rowsPerPage: '{{count}} par page',
    translations: 'Traductions',
    description: 'Description',
    formatJson: 'Formater JSON',
    jsonPlaceholder: "Saisir les données de l'aliment au format JSON",
    jsonInstructions: 'Instructions de Format JSON',
    jsonInstructionName:
      'Le nom est obligatoire et doit être une chaîne de caractères',
    jsonInstructionCategory:
      'CategoryId est obligatoire et doit être un nombre',
    jsonInstructionCountry: 'CountryId est optionnel et doit être un nombre',
    jsonInstructionStatus: "Le statut doit être l'un des suivants",
    jsonInstructionTranslations:
      'Les traductions doivent être un enregistrement de codes de langue vers des objets de traduction',
    jsonUpdateError: 'Erreur lors de la mise à jour de {{field}} : {{error}}',
    hideFilters: 'Masquer les Filtres',
    showFilters: 'Afficher les Filtres',
    totalItems: '{{count}} éléments au total',
    aiPrompt: {
      title: "Générer des Données d'Aliments avec l'IA",
      description: "Utiliser l'IA pour aider à générer des données d'aliments",
      inputLabel: "Nom de l'Aliment",
      inputPlaceholder: "Saisir un nom d'aliment",
      buttonText: "Générer avec l'IA",
      copyPrompt: 'Copier le Prompt',
      openInChatGPT: 'Ouvrir dans ChatGPT',
      promptCopied: 'Prompt copié dans le presse-papiers !',
      instructions: 'Instructions :',
      step1: "1. Saisir un nom d'aliment",
      step2: '2. Cliquer sur "Générer avec l\'IA" ou copier le prompt',
      step3:
        '3. Coller le prompt dans ChatGPT ou cliquer sur "Ouvrir dans ChatGPT"',
      step4:
        "4. Copier la réponse JSON et l'utiliser pour créer un nouvel élément d'aliment",
    },
  },
  languages: {
    en: 'Anglais',
    nl: 'Néerlandais',
    tr: 'Turc',
    de: 'Allemand',
    fr: 'Français',
    es: 'Espagnol',
    it: 'Italien',
    pt: 'Portugais',
  },
};

export default managementTranslations;
